import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTimes } from 'react-icons/fa';
import './CreateDeviceModal.css';
import { crusaders } from '../../../../ClientUpdater/ClientUpdater';
import { AtomHeaderDataState } from '../../../../RecoilState/AtomHeaderDataState';
import { useRecoilValue } from 'recoil';

const CreateDeviceModal = ({ isOpen, onClose }) => {
    const roleValue = useRecoilValue(AtomHeaderDataState)
    const [viewDevice, setViewDevice] = useState([]);
    const [viewSites, setViewSites] = useState([]);
    const [viewCompanyWeb, setCompanyWeb] = useState([]);
    const [selectedCoNo, setSelectedCoNo] = useState('');
    const [selectedSite, setSelectedSite] = useState('');
    const [selectedCompanyWeb, setSelectedCompanyWeb] = useState('');
    const [message, setMessage] = useState("");
    const [formData, setFormData] = useState({
        deviceId: '',
        deviceName: ''
        // Add other fields as needed
    });

    useEffect(() => {
        const fetchCompanyNos = async () => {
            try {
                const response = await axios.get(`https://worxit.co.za/api/${crusaders}/fetch/fetchCompanyNo.php`);
                const newData = response.data.records;
                setViewDevice(newData);
                console.log('newData: ', newData)
              } catch (error) {
                console.error("Error fetching data: ", error);
              }
        };
    
        fetchCompanyNos(); // Initial call
        const intervalId = setInterval(fetchCompanyNos, 5000);
        return () => clearInterval(intervalId);
      }, [setViewDevice]); // Empty dependency array to run this effect only once

      useEffect(() => {
        const fetchSites = async () => {
            try {
                const response = await axios.get(`https://worxit.co.za/api/${crusaders}/fetch/fetchSites.php`);
                const newData = response.data.records;
                setViewSites(newData);
                console.log('newData: ', newData)
              } catch (error) {
                console.error("Error fetching data: ", error);
              }
        };
    
        fetchSites(); // Initial call
        const intervalId = setInterval(fetchSites, 5000);
        return () => clearInterval(intervalId);
      }, [setViewSites]); // Empty dependency array to run this effect only once

      useEffect(() => {
        const fetchCompanyWeb = async () => {
            try {
                const response = await axios.get(`https://worxit.co.za/api/${crusaders}/fetch/fetchCompanyWeb.php`);
                const newData = response.data.records;
                setCompanyWeb(newData);
                console.log('newData: ', newData)
              } catch (error) {
                console.error("Error fetching data: ", error);
              }
        };
    
        fetchCompanyWeb(); // Initial call
        const intervalId = setInterval(fetchCompanyWeb, 5000);
        return () => clearInterval(intervalId);
      }, [setCompanyWeb]); // Empty dependency array to run this effect only once


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
        ...formData,
        [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
      
        const sendData = {
          deviceId: formData.deviceId,
          deviceName: formData.deviceName,
          coNo: selectedCoNo,
          site: selectedSite,
        };
      
        console.log(sendData);
      
        axios.post(`https://worxit.co.za/api/${crusaders}/create/createDevices.php`, sendData)
          .then((res) => {
            if (res.data.success) {
              onClose();  // Close the modal only if the response is true
              setFormData({ deviceId: "", coNo: "", site: "" });
            } else {
              setMessage(res.data.message);
            }
          })
          .catch((error) => {
            console.error(error);
            setMessage(error.message); // Assuming the error message is meaningful
          });
      };
      

    if (!isOpen) {
        return null;
    }

  return (
    <div className="create-device-modal">
      <div className="create-device-modal-content">
        <div className='modalHeader'>
          <div className='header-title-cont'>
            <h3 className="create-device-title">Create Device</h3>
          </div>
          {roleValue[0]?.role === 0 || roleValue[0]?.role === 1 ? (
             <div className='defaultBtnCont'>
              <span onClick={handleSubmit} className='defaultBtn' type="submit">Add Device</span>
             </div>
            ) : null
          }
          <div onClick={onClose} className="closeContAllModals">
            <span className="closeAllModalIcon">
              <FaTimes />
            </span>
          </div>
        </div>
            <div className='createDeviceDeviceIdCont'>
              <div className='createDeviceDeviceIdTitle'>
                <label className='searchName'>
              Device ID:
              </label>
              </div>
              <div className='createDeviceDeviceId'>
                <input
                className='createDeviceDeviceIdInput'
                type="text"
                name="deviceId"
                value={formData.deviceId}
                onChange={handleChange}
              />
              </div>            
            </div>
            <div className='createDeviceDeviceIdCont'>
              <div className='createDeviceDeviceIdTitle'>
                <label className='searchName'>
              Device Name:
              </label>
              </div>
              <div className='createDeviceDeviceId'>
                <input
                className='createDeviceDeviceIdInput'
                type="text"
                name="deviceName"
                value={formData.deviceName}
                onChange={handleChange}
              />
              </div>            
            </div>
            <div className='createDeviceSelectedCoNoCont'>
              <div className='createDeviceCompanyNoTitle'>
                  <label className='searchName' htmlFor="CreateDeviceCompanyNoDropdown">Company No:</label>
              </div>
              <div className='dropdownCompanyNoCont'>
                  <select
                  id="CreateDeviceCompanyNoDropdown"
                  value={selectedCoNo}
                  onChange={(e) => setSelectedCoNo(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  {viewDevice.map((item) => (
                    <option key={item.id} value={item.coNo}>
                      {item.coNo}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='createDeviceSelectedCoNoCont'>
              <div className='createDeviceCompanyNoTitle'>
                  <label className='searchName' htmlFor="CreateDeviceCompanyNoDropdown">Site:</label>
              </div>
              <div className='dropdownCompanyNoCont'>
                  <select
                  id="CreateDeviceCompanyNoDropdown"
                  value={selectedSite}
                  onChange={(e) => setSelectedSite(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  {viewSites.map((item) => (
                    <option key={item.id} value={item.site}>
                      {item.site}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='createDeviceSelectedCoNoCont'>
              <div className='createDeviceCompanyNoTitle'>
                  <label className='searchName' htmlFor="CreateDeviceCompanyNoDropdown">Company Web:</label>
              </div>
              <div className='dropdownCompanyNoCont'>
                  <select
                  id="CreateDeviceCompanyNoDropdown"
                  value={selectedCompanyWeb}
                  onChange={(e) => setSelectedCompanyWeb(e.target.value)}
                >
                  <option value="">-- Select --</option>
                  {viewCompanyWeb.map((item) => (
                    <option key={item.id} value={item.companyWeb}>
                      {item.companyWeb}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            
             <div className='messagesCont'>
                {message && <p className='error-message'>{message}</p>}
             </div>
           {/* <div className="close-cont-create-device-modal">
            <span className="close-create-user-modal-icon">
              Add Device
            </span>
          </div> */}
        
      </div>
    </div>
  );
};

export default CreateDeviceModal;
